// extracted by mini-css-extract-plugin
module.exports = {"Block":"Block_Block__149fP","Hide":"Block_Hide__259OJ","BlockContent":"Block_BlockContent__3mMen","SvgWrapper":"Block_SvgWrapper__d8zZB","TitleWrapper":"Block_TitleWrapper__N1avo"};